import React from 'react';

import { IconProps } from './types';

export const CrownSecondaryIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = 'currentColor', ...props }, forwardedRef) => {
    return (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={forwardedRef}
      >
        <path
          d="M20.6719 16.2236C21.1094 16.1104 21.5664 16.4131 21.5986 16.8643C21.6689 17.8398 21.3965 18.6689 20.7822 19.2832C19.3574 20.7002 15.2178 21 12 21C8.78222 21 4.64257 20.7002 3.21777 19.2822C2.60351 18.668 2.33105 17.8398 2.40136 16.8633C2.43359 16.4131 2.89062 16.1104 3.32812 16.2236C5.09765 16.6826 8.08105 17.25 12 17.25C15.9189 17.25 18.9023 16.6826 20.6719 16.2236ZM2.85937 14.5322C2.64746 14.4688 2.47558 14.3193 2.38964 14.1162C1.6289 12.3096 0.757807 8.9082 2.97753 5.58789C3.14257 5.33203 3.45019 5.20508 3.74218 5.26465C5.51953 5.61719 6.99706 6.71973 7.89746 7.55273C8.40038 6.16504 9.46484 3.95996 11.5488 2.40039C11.8135 2.20313 12.1865 2.20313 12.4502 2.40039C14.5352 3.96094 15.5996 6.16602 16.1016 7.55273C17.0019 6.71973 18.4795 5.61719 20.2568 5.26465C20.5488 5.20508 20.8564 5.33203 21.0215 5.58789C23.2412 8.9082 22.3701 12.3096 21.6094 14.1162C21.5234 14.3203 21.3516 14.4697 21.1396 14.5332C19.7148 14.957 16.4756 15.75 12 15.75C7.52441 15.75 4.28515 14.957 2.85937 14.5322Z"
          fill={color}
        />
      </svg>
    );
  },
);
